/*
 import TOOLTIP from '../../../../constants/artifact_tooltip.constant';
 */
import EVENTS from '../../../../constants/xray-ui_events.constants';

export class SetLicenseController {

	constructor($scope, JFrogEventBus, User, $state, XRayUIModelSaver, LicenseDao, TOOLTIPS, JFrogModal,$rootScope) {

		$scope.$parent.Settings.showButtons = true;
		$scope.$parent.Settings.currentSubController = this;
		$rootScope.h1Header = 'Activate Trial License';
		this.TOOLTIP = TOOLTIPS.admin.license;
		this.modal = JFrogModal;
		this.LicenseDao = LicenseDao;
		this.$state = $state;
		this.JFrogEventBus = JFrogEventBus;
		this.User = User;
		//        this.TOOLTIP = TOOLTIP.admin.configuration.registerPro;
		this.modelSaver = XRayUIModelSaver.createInstance(this, ['registerDetails']);
		this.getData();
        $scope.$on('$destroy', () => {
            $rootScope.h1Header='';
        })
	}

	save(registerDetails) {
		registerDetails = registerDetails || this.registerDetails;
		registerDetails.key = registerDetails.key ? registerDetails.key.split('\n').join('').split('\r').join('') : '';
		this.LicenseDao.update(registerDetails).$promise.then((data) => {
			// Refresh the home page footer with the new license details
			//            this.User.loadUser(true);
			//            this.modelSaver.save();


			if (data.status === 200) {
				this.modelSaver.save();
				this.JFrogEventBus.dispatch(EVENTS.FOOTER_REFRESH);
				this.$state.go('home');

			}
			else {
				this.getData();
			}

		});
	}


	getData() {
		this.LicenseDao.get().$promise.then((data) => {
			if (data.key) {
				this.gotLicense = true;
			} else {
				this.gotLicense = false;
			}
			this.registerDetails = data;
			this.modelSaver.save();
		});
	}

	delete() {

		this.modal.confirm(`Are you sure you want to remove current ${this.registerDetails.license_type} license?`)
		    .then(() => {
			    this.LicenseDao.delete().$promise.then((data) => {
				    this.getData();
			    });
		    });

	}


	cancel() {
		this.$state.go('home');
	}


}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/set_license/set_license.controller.js